import { trpc } from "../../trpc";

interface Input {
  id: string | undefined;
  check: ZapPermissionChecks;
  projectId: string | undefined | null;
}

interface Options {
  enabled: boolean;
}

const DEFAULT_OPTS: Options = { enabled: true };

export enum ZapPermissionChecks {
  CanEdit = "can_edit",
  CanDelete = "can_delete",
  CanChangeOwner = "can_change_owner",
}

export function useQueryZapPermissions(
  { id, check = ZapPermissionChecks.CanEdit, projectId }: Input,
  options: Options | undefined = DEFAULT_OPTS,
) {
  const { data } = trpc.permission.zap.useQuery(
    { id: id || "", check },
    {
      enabled: !!id && !!projectId && options.enabled,
      staleTime: 10 * 60 * 1000,
    },
  );

  const keys = {
    [ZapPermissionChecks.CanEdit]: "canEdit",
    [ZapPermissionChecks.CanDelete]: "canDelete",
    [ZapPermissionChecks.CanChangeOwner]: "canChangeOwner",
  };

  const can = data?.results?.[0]?.permissionsChecks?.[keys[check]] || false;

  return {
    can,
  };
}
